import React, { useState } from 'react';
import TypeOption from './AxleOption.tsx';
import { useAppState } from '../../BikesAppState.tsx';
import { NodeId } from '../../Types/Types.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';

import './AxleSelector.less';

const AxleSelector = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const { fitAssistantBikesData, selectOption } = useAppState();
  const axleData = fitAssistantBikesData?.Steps?.find((stepData) => stepData.Parameter === 'axle');
  const translations = fitAssistantBikesData?.Translations;

  const toAxleValue = (title: string): string => {
    const normalized = title.trim().toLowerCase();
    if (normalized.includes('thru')) {
      return 'thru';
    }
    if (normalized.includes('qr')) {
      return 'qr';
    }
    if (normalized.includes('solid')) {
      return 'solid';
    }
    return normalized;
  };

  return (
    <>
      <div className="type-selector d-flex flex-column justify-content-center">
        <div className="type-options">
          {axleData?.ContentOptions?.map((option, index) => {
            return (
              <TypeOption
                option={option}
                selected={selectedIndex === index}
                onClick={() => {
                  setSelectedIndex(index);
                }}
                key={index}
              />
            );
          })}
        </div>
      </div>
      <Buttons visible>
        <PrimaryButton
          visible
          disabled={selectedIndex === null}
          text={translations?.next ?? ''}
          onClick={() => {
            const selected = axleData?.ContentOptions?.[selectedIndex ?? 0];
            if (!selected) {
              return;
            }
            selectOption({
              value: toAxleValue(selected.SelectorValue),
              label: selected.Title,
              nextNodeId: selected.NextStep as NodeId,
            });
          }}
        />
      </Buttons>
    </>
  );
};

export default AxleSelector;
